// tslint:disable: quotemark
export enum CollapsibleTableRowStateEnum {
	Expanded = 'expanded',
	Collapsed = 'collapsed'
}
